import { Component, OnInit } from '@angular/core';
import { AdminComponent } from '../../../pages/admin/admin.component';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  constructor(
    public app: AdminComponent
  ) { }

  ngOnInit(): void {
  }

}
